// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._195g1ejb{margin-inline:var(--ds-space-300,24px)}\n._19pku2gc{margin-top:var(--ds-space-100,8px)}\n._otyrx0bf{margin-bottom:var(--ds-space-negative-100,-8px)}", ""]);
// Exports
module.exports = exports;
